import React, { useEffect, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import ShopifyIntegrationActions from '@Actions/integrations/shopifyIntegrationActions';
import StepInfo from './StepsInfo';
import ShopifyMapLocations from './Steps/ShopifyMapLocations';
import InitialImport from './Steps/InitialImport';
import SyncSetup from './Steps/SyncSetup';
import ShopifySuccess from './Steps/ShopifySuccess';

/**
 *
 */
const ShopifySetup = ({
  user, getShopifyConnections, getShopifyConnectionsLoading, getTenantsLoading,
}) => {
  const [step, setStep] = useState('');

  useEffect(() => {
    getShopifyConnections(user?.tenant_info?.org_id, (connections) => {
      if (connections?.length > 0) {
        setStep(1);
      }
    });
  }, []);

  return (
    <Fragment>
      <div className="shopify-integration-wrapper">
        <div className="shopify-integration__heading">Shopify Integration </div>
        <div className="ant-row">
          <div className="ant-col-md-5">
            <StepInfo step={step} loading={getShopifyConnectionsLoading || getTenantsLoading} />
          </div>
          {getShopifyConnectionsLoading ? (
            <div className="shopify-integration__loader__wrapper">

              { [...Array(5).keys()].map((item) => (
                <div key={item} className="shopify-integration__loader-row">
                  <div className="loadingBlock  shopify-integration__loader__line1" />
                  <div className="loadingBlock  shopify-integration__loader__line2" />
                  <div className="loadingBlock  shopify-integration__loader__line3" />
                </div>
              ))}
              <div className="loadingBlock shopify-integration__loader__line-btn1" />
              <div className="loadingBlock shopify-integration__loader__line-btn2" />
            </div>
          )
            : (
              <div className="ant-col-md-19">
                {step === 1 && (<ShopifyMapLocations setStep={setStep} />)}
                {step === 2 && (<InitialImport setStep={setStep} />)}
                {step === 3 && (<SyncSetup setStep={setStep} />)}
                {step === 4 && (<ShopifySuccess setStep={setStep} />)}
              </div>
            )}

        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,

});

const mapDispatchToProps = (dispatch) => ({
  getShopifyConnections: (orgId, callback) => dispatch(ShopifyIntegrationActions.getShopifyConnections(orgId, callback)),
});

ShopifySetup.propTypes = {
  user: PropTypes.any,
  history: PropTypes.any,
  getShopifyConnectionsLoading: PropTypes.bool,
  getTenantsLoading: PropTypes.bool,
  getShopifyConnections: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShopifySetup));
